import api from "../axios";

// 회사
export const listCompanies = (params) => api.get("companies/", { params });
export const createCompany = (data) => api.post("companies/", data);
export const retrieveCompany = (id) => api.get(`companies/${id}/`);
export const updateCompany = (id, data) => api.put(`companies/${id}/`, data);
export const patchCompany = (id, data) => api.patch(`companies/${id}/`, data);
export const deleteCompany = (id) => api.delete(`companies/${id}/`);

// 공장
export const listFactories = (params) => api.get("factories/", { params });
export const createFactory = (data) => api.post("factories/", data);
export const updateFactory = (id, data) => api.put(`factories/${id}/`, data);
export const patchFactory = (id, data) => api.patch(`factories/${id}/`, data);
export const deleteFactory = (id) => api.delete(`factories/${id}/`);
